<template>
  <div class="extra-payment-calculator">
    <div
      class="sliders calc-main mortgage mb-5"
      data-name="Extra Payment calculator"
    >
      <div
        v-if="!isSubmitted"
        id="sliders-page"
      >
        <section class="calc-main__container">
          <form
            class="form_wrapper"
            action
          >
            <nav class="xtra-calc-nav">
              <div
                id="results-nav-tab1"
                class="nav nav-tabs"
                role="tablist"
              >
                <a
                  id="nav-one-time-info-tab"
                  class="nav-item nav-link"
                  data-toggle="tab"
                  href="#nav-one-time-info"
                  role="tab"
                  aria-controls="nav-one-time-info"
                  aria-selected="true"
                  @click="tab = 0"
                ><span :class="{ active: tab === 0 }">One-Time</span></a>
                <a
                  id="nav-monthly-info-tab"
                  class="nav-item nav-link"
                  data-toggle="tab"
                  href="#nav-monthly-info"
                  role="tab"
                  aria-controls="nav-monthly-info"
                  aria-selected="false"
                  @click="tab = 1"
                ><span :class="{ active: tab === 1 }">Monthly</span></a>
              </div>
            </nav>
            <div class="row">
              <div class="col-12 col-md-6 input-fields">
                <div
                  id="input"
                  class="input__wrapper"
                >
                  <div
                    id="nav-tabContent1"
                    class="tab-content"
                  >
                    <div
                      id="nav-one-time-info"
                      class="tab-pane"
                      :class="{ 'show active': tab === 0 }"
                      role="tabpanel"
                      aria-labelledby="nav-one-time-info-tab"
                    >
                      <div
                        id="extra-payment-input-group"
                        class="form-group"
                      >
                        <label
                          for="extra-payment-one-input-field"
                        >Extra Payment - One-Time</label>
                        <span
                          class="tooltipContent"
                          data-toggle="tooltip"
                          data-placement="right"
                          aria-hidden="true"
                          data-html="true"
                          title="<p>Enter the one-time extra payment you plan to make on your mortgage.</p><p>Consult your mortgage company before making an extra payment to ensure it is applied to the principal.</p>"
                        >
                          <i class="fa fa-question-circle fa-1x" />
                        </span>
                        <div class="input-group mb-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text">$</div>
                          </div>
                          <CurrencyComponent
                            v-model.number="$v.oneTimeExtraPayment.$model"
                            class="form-control"
                            :class="{
                              'is-invalid':
                                $v.oneTimeExtraPayment.$error ||
                                $v.oneTimeExtraPayment.$invalid
                            }"
                          />
                          <div class="input-group-append">
                            <div class="input-group-text">&nbsp;</div>
                          </div>
                          <input
                            id="extra-payment-one-input-range"
                            v-model.number="oneTimeExtraPayment"
                            type="range"
                            class="custom-range"
                            min="0"
                            max="10000"
                          >
                          <div class="invalid-feedback">
                            <span
                              v-if="
                                !$v.oneTimeExtraPayment.between ||
                                  !$v.oneTimeExtraPayment.required
                              "
                            >{{ errorMsgPre }} ${{ Number($v.oneTimeExtraPayment.$params.between.min).toLocaleString() }}
                              and ${{
                                Number(
                                  $v.oneTimeExtraPayment.$params.between.max
                                ).toLocaleString()
                              }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="nav-monthly-info"
                      class="tab-pane"
                      :class="{ 'show active': tab === 1 }"
                      role="tabpanel"
                      aria-labelledby="nav-monthly-info-tab"
                    >
                      <div
                        id="extra-payment-monthly-input-group"
                        class="form-group"
                      >
                        <label
                          for="extra-payment-monthly-input-field"
                        >Extra Payment - Monthly</label>
                        <span
                          class="tooltipContent"
                          data-toggle="tooltip"
                          data-placement="right"
                          aria-hidden="true"
                          data-html="true"
                          title="<p>Enter the additional amount you plan to pay on your mortgage each month.</p><p>Consult your mortgage company before making an extra payment to ensure it is applied to the principal.</p>"
                        >
                          <i class="fa fa-question-circle fa-1x" />
                        </span>
                        <div class="input-group mb-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text">$</div>
                          </div>
                          <CurrencyComponent
                            v-model.number="$v.monthlyExtraPayment.$model"
                            class="form-control"
                            :class="{
                              'is-invalid':
                                $v.monthlyExtraPayment.$error ||
                                $v.monthlyExtraPayment.$invalid
                            }"
                          />
                          <input
                            id="extra-payment-monthly-input-range"
                            v-model.number="monthlyExtraPayment"
                            type="range"
                            class="custom-range"
                            min="0"
                            max="10000"
                          >
                          <div class="invalid-feedback">
                            <span
                              v-if="
                                !$v.monthlyExtraPayment.between ||
                                  !$v.monthlyExtraPayment.required
                              "
                            >{{ errorMsgPre }} ${{ Number($v.monthlyExtraPayment.$params.between.min).toLocaleString() }}
                              and ${{
                                Number(
                                  $v.monthlyExtraPayment.$params.between.max
                                ).toLocaleString()
                              }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="mortgage-loan-input-group"
                    class="form-group"
                  >
                    <label
                      for="mortgage-loan-input-field"
                    >Mortgage Loan Amount</label>
                    <span
                      class="tooltipContent"
                      data-toggle="tooltip"
                      data-placement="right"
                      aria-hidden="true"
                      data-html="true"
                      title="<p>Enter the amount you plan to borrow for your home purchase.</p><p>Also referred to as a mortgage, your loan amount is the home sales price minus your down payment amount.</p>"
                    >
                      <i class="fa fa-question-circle fa-1x" />
                    </span>
                    <div class="input-group mb-2">
                      <div class="input-group-prepend">
                        <div class="input-group-text">$</div>
                      </div>
                      <CurrencyComponent
                        v-model.number="$v.mortgageLoanAmount.$model"
                        class="form-control"
                        :class="{
                          'is-invalid':
                            $v.mortgageLoanAmount.$error ||
                            $v.mortgageLoanAmount.$invalid
                        }"
                      />
                      <div class="input-group-append">
                        <div class="input-group-text">&nbsp;</div>
                      </div>
                      <input
                        id="mortgage-loan-input-range"
                        v-model.number="mortgageLoanAmount"
                        type="range"
                        class="custom-range"
                        min="10000"
                        max="1000000"
                      >
                      <div class="invalid-feedback">
                        <span
                          v-if="
                            !$v.mortgageLoanAmount.between ||
                              !$v.mortgageLoanAmount.required
                          "
                        >{{ errorMsgPre }} ${{ Number( $v.mortgageLoanAmount.$params.between.min).toLocaleString() }}
                          and ${{
                            Number(
                              $v.mortgageLoanAmount.$params.between.max
                            ).toLocaleString()
                          }}</span>
                      </div>
                    </div>
                  </div>
                  <div
                    id="interest-rate-input-group"
                    class="form-group"
                  >
                    <label for="interest-rate-input-field">Interest Rate</label>
                    <span
                      class="tooltipContent"
                      data-toggle="tooltip"
                      data-placement="right"
                      aria-hidden="true"
                      data-html="true"
                      title="<p>Enter the estimated annual interest rate you expect to pay your lender for a mortgage loan.  This rate excludes other fees such as mortgage insurance, closing costs, loan origination fees, etc.</p><p>Interest rates can vary and are determined by a number of factors including the loan term and type, credit score, down payment, points, and home price. For current interest rates, visit your local bank, credit union, mortgage company, or check online.</p>"
                    >
                      <i class="fa fa-question-circle fa-1x" />
                    </span>
                    <div class="input-group mb-2">
                      <div class="input-group-prepend">
                        <div class="input-group-text">&nbsp;</div>
                      </div>
                      <input
                        id="interest-rate-input-field"
                        v-model.number="$v.interestRatePercent.$model"
                        type="number"
                        step="0.25"
                        class="form-control"
                        :class="{
                          'is-invalid':
                            $v.interestRatePercent.$error ||
                            $v.interestRatePercent.$invalid
                        }"
                      >
                      <div class="input-group-append">
                        <div class="input-group-text percentage">%</div>
                      </div>
                      <input
                        id="interest-rate-input-range"
                        v-model.number="interestRatePercent"
                        type="range"
                        class="custom-range"
                        min="1"
                        max="11"
                        step="0.25"
                      >
                      <div class="invalid-feedback">
                        <span
                          v-if="
                            !$v.interestRatePercent.between ||
                              !$v.interestRatePercent.required
                          "
                        >{{ errorMsgPre }}
                          {{
                            Number(
                              $v.interestRatePercent.$params.between.min
                            ).toLocaleString()
                          }}% and
                          {{
                            Number(
                              $v.interestRatePercent.$params.between.max
                            ).toLocaleString()
                          }}%</span>
                      </div>
                    </div>
                  </div>
                  <div
                    id="term-input-group"
                    class="form-group"
                  >
                    <label for="term-input-select">Term</label>
                    <span
                      class="tooltipContent"
                      data-toggle="tooltip"
                      data-placement="right"
                      aria-hidden="true"
                      data-html="true"
                      title="<p>Select the length of the loan repayment period.</p><p>Loan terms affect your monthly payment. A longer term mortgage (30-year) means lower principal payments each month, but you will pay more in interest over the life of the loan. A shorter term mortgage (15-year) means monthly principal payments are higher but the amount of interest paid over the life of the loan is lower.</p>"
                    >
                      <i class="fa fa-question-circle fa-1x" />
                    </span>
                    <div class="input-group mb-2">
                      <div class="input-group-prepend">
                        <div class="input-group-text">&nbsp;</div>
                      </div>
                      <select
                        id="term-input-select"
                        v-model.number="term"
                        class="form-control"
                      >
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option selected>30</option>
                      </select>
                      <div class="input-group-append">
                        <div class="input-group-text yrs">yrs</div>
                      </div>
                      <input
                        id="term-input-range"
                        v-model.number="term"
                        type="range"
                        class="custom-range"
                        min="10"
                        max="30"
                        step="5"
                      >
                    </div>
                  </div>
                  <div
                    id="date-loan-closed-input-group"
                    class="form-group"
                  >
                    <label>Date Loan Closed</label>
                    <span
                      class="tooltipContent"
                      data-toggle="tooltip"
                      data-placement="right"
                      aria-hidden="true"
                      data-html="true"
                      title="<p>This date is located on the settlement documents received at closing.</p>"
                    >
                      <i class="fa fa-question-circle fa-1x" />
                    </span>
                    <div>
                      <datepicker
                        v-model="loanCloseDate"
                        class="xtra-date"
                        :typeable="true"
                        :format="datePickerFormat"
                      />
                    </div>
                  </div>
                </div>
                <div
                  id="button-section"
                  class="form-group col col-12"
                >
                  <span
                    class="text-button button-white fm-btn"
                    onclick="dataLayer.push({'event': 'calculator-cta-link', 'calculatorName': 'Mortgage calculator', 'calculatorCta' : 'Reset'});"
                    @click="reset"
                  >
                    Reset
                  </span>
                </div>
              </div>
              <div
                id="result"
                class="col-12 col-md-6"
              >
                <div class="sticky">
                  <nav class="xtra-pay-nav">
                    <div id="results-nav-tab">
                      <div class="deposit-details">Potential Savings</div>
                    </div>
                  </nav>
                  <div
                    id="nav-tabContent"
                    class="tab-content"
                  >
                    <div
                      v-if="tab === 0"
                      id="nav-one-time-result"
                      class="tab-pane fade show active"
                      role="tabpanel"
                      aria-labelledby="nav-one-time-result"
                    >
                      <div class="row donut-loan align-center">
                        <div
                          class="form-group col col-12 amount-head text-center"
                        >  <label class="big mt-2">Potential Savings</label>
                          <span class="big mb-2">{{ currencyFormat(oneTimeSavings) }}</span>
                        </div>
                        <div class="col-6 donut-loan__item text-center border-right one-time-pay">
                          <span class="card-header-xtra">One-Time payment</span>
                          <span class="monthly-deposit-amount">{{ currencyFormat(oneTimeExtraPayment) }}</span>
                        </div>
                        <div class="col-6 donut-loan__item text-center">
                          <span class="card-header-xtra">Loan repayment period reduction</span>
                          <span class="monthly-deposit-amount">{{ Math.trunc(oneTimeRepaymentPeriodReducedBy) }} Months</span>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="tab === 1"
                      id="nav-monthly-result"
                      class="tab-pane fade show active"
                      role="tabpanel"
                      aria-labelledby="nav-monthly-result"
                    >
                      <div class="row donut-loan align-center">
                        <div
                          class="form-group col col-12 amount-head text-center"
                        >  <label class="big mt-2">Potential Savings</label>
                          <span class="big mb-2">{{ currencyFormat(monthlySavings) }}</span>
                        </div>
                        <div class="col-6 donut-loan__item text-center border-right month-pay">
                          <span class="card-header-xtra">Monthly payment</span>
                          <span class="monthly-deposit-amount">{{ currencyFormat(monthlyExtraPayment) }}</span>
                        </div>
                        <div class="col-6 donut-loan__item text-center">
                          <span class="card-header-xtra">Loan repayment period reduction</span>
                          <span class="monthly-deposit-amount">
                            <span class="xtra-payment-years">({{ Math.round(repaymentPeriodReducedBy / 12) }} Years)</span>
                            {{ repaymentPeriodReducedBy }} Months
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
      <div
        v-if="isSubmitted"
        id="result-page"
      >
        <div class="col">
          <div class="block-main">
            <div class="block-main-header">
              <h3 class="extra-header">YOU CAN EXPECT TO SAVE:</h3>
            </div>
            <div class="block-main-content">
              <div class="row">
                <label class="col-8">Total savings in interest</label>
                <span class="col-4 block-main-content--right">
                  {{ tab === 0 ? currencyFormat(oneTimeSavings) : currencyFormat(monthlySavings) }}
                </span>
              </div>
              <div class="row">
                <label class="col-8">By paying an extra principal payment</label>
              </div>
              <div class="block-main-content--padded">
                <div
                  v-if="tab === 0"
                  class="row"
                >
                  <label class="col-8">One-time</label>
                  <span class="col-4 block-main-content--right">{{ currencyFormat(oneTimeExtraPayment) }}</span>
                </div>
                <div
                  v-if="tab === 1"
                  class="row"
                >
                  <label class="col-8">Monthly</label>
                  <span class="col-4 block-main-content--right">{{ currencyFormat(monthlyExtraPayment) }}/MO</span>
                </div>
              </div>
            </div>
            <div class="block-main-header">
              <h3 class="extra-header">INFORMATION ABOUT YOUR CURRENT MORTGAGE:</h3>
            </div>
            <div class="block-main-content">
              <div class="row">
                <label class="col-8">Mortgage Loan Amount</label>
                <span class="col-4 block-main-content--right">{{ currencyFormat(mortgageLoanAmount) }}</span>
              </div>
              <div class="row">
                <label class="col-8">Principal & Interest (P&I) Payment</label>
                <span class="col-4 block-main-content--right">{{ currencyFormat(monthlyPrincipalAndInterestPayment) }}/MO</span>
              </div>
              <div class="row">
                <label class="col-8">Interest Rate</label>
                <span class="col-4 block-main-content--right">{{ interestRatePercent }}%</span>
              </div>
              <div class="row">
                <label class="col-8">Term</label>
                <span class="col-4 block-main-content--right">{{ term }}YRS</span>
              </div>
              <div class="row">
                <label class="col-8">Date loan closed</label>
                <span class="col-4 block-main-content--right">{{ loanCloseDate.toLocaleDateString("en-US") }}</span>
              </div>
              <div class="row">
                <label class="col-8">Months since loan closed</label>
                <span class="col-4 block-main-content--right">{{ monthsSinceLoanClose }}</span>
              </div>
              <div class="row">
                <label class="col-8">Number of payments remaining</label>
                <span class="col-4 block-main-content--right">
                  {{ remainingPayments }} ( {{ Math.round(remainingPayments / 12) }} YRS)</span>
              </div>
              <div class="row">
                <label class="col-8">Principal balance estimate (as of today)</label>
                <span class="col-4 block-main-content--right">{{ currencyFormat(principalBalanceEstimate) }}</span>
              </div>
              <div class="row">
                <label class="col-8">Principal & interest (P&I) balance estimate</label>
                <span class="col-4 block-main-content--right">{{ currencyFormat(remainingPrincipalAndInterest) }}</span>
              </div>
            </div>
            <div class="block-main-header">
              <h3 class="extra-header">INFORMATION ABOUT YOUR POTENTIAL MORTGAGE AFTER YOUR EXTRA PAYMENT:</h3>
            </div>
            <div class="block-main-content">
              <div
                v-if="tab === 0"
                class="row"
              >
                <label class="col-8">One-time extra payment</label>
                <span class="col-4 block-main-content--right">{{ currencyFormat(oneTimeExtraPayment) }}</span>
              </div>
              <div
                v-if="tab === 1"
                class="row"
              >
                <label class="col-8">Monthly extra payment</label>
                <span class="col-4 block-main-content--right">{{ currencyFormat(monthlyExtraPayment) }}/MO</span>
              </div>
              <div
                v-if="tab === 1"
                class="row"
              >
                <label class="col-8">New monthly total payment</label>
                <span class="col-4 block-main-content--right">{{ currencyFormat(newMonthlyPayment) }}/MO</span>
              </div>
              <div
                v-if="tab === 1"
                class="row"
              >
                <label class="col-8">New number of payments remaining</label>
                <span class="col-4 block-main-content--right">  {{ tab === 0 ? Math.round(newOneTimeRemainingPayments) : Math.round(newRemainingPayments) }}</span>
              </div>
              <div class="row">
                <label class="col-8">New total principal & interest (P&I) remaining</label>
                <span class="col-4 block-main-content--right">
                  {{ tab === 0 ? currencyFormat(newRemainingOneTimePrincipalAndInterest)
                  : currencyFormat(newRemainingMonthlyPrincipalAndInterest) }}
                </span>
              </div>
              <div class="row">
                <label class="col-8">New principal balance estimate</label>
                <span class="col-4 block-main-content--right">
                  {{ currencyFormat(newPrincipalBalance) }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 bckBtn">
            <button
              class="btn btn-block btn-primary"
              type="submit"
              @click.prevent="isSubmitted = !isSubmitted"
            >
              <i class="fa fa-caret-left" /> Back to Calculator
            </button>
          </div>
          <div class="col-12">
            <p>
              These calculator results are estimates based on your inputs. Contact a
              bank, credit union, housing advisor, or lender to determine accurate
              figures.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import jQuery from 'jquery';
import { required, between } from 'vuelidate/lib/validators';
import Datepicker from 'vuejs-datepicker';
import CurrencyComponent from '../components/Currency.vue';

const $ = jQuery;
const today = new Date();
const currency = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
  style: 'currency',
  currency: 'USD',
});

export default {
  name: 'ExtraPaymentCalculator',
  components: {
    Datepicker,
    CurrencyComponent,
  },
  data() {
    return this.init();
  },
  validations: {
    oneTimeExtraPayment: {
      required,
      between: between(0, 10000),
    },
    monthlyExtraPayment: {
      required,
      between: between(0, 10000),
    },
    mortgageLoanAmount: {
      required,
      between: between(10000, 1000000),
    },
    interestRatePercent: {
      required,
      between: between(1, 11),
    },
  },
  computed: {
    monthlyPrincipalAndInterestPayment() {
      return this.pmt(
        this.interestRatePercent / 100 / 12,
        this.term * 12,
        this.mortgageLoanAmount
      );
    },
    monthsSinceLoanClose() {
      const monthTo = today.getMonth();
      const yearTo = today.getFullYear();
      const monthFrom = this.loanCloseDate.getMonth();
      const yearFrom = this.loanCloseDate.getFullYear();
      const diff = monthTo - monthFrom + (yearTo - yearFrom) * 12;
      return diff < 0 ? 0 : diff;
    },
    remainingPayments() {
      return this.term * 12 - this.monthsSinceLoanClose;
    },
    remainingPrincipalAndInterest() {
      return this.monthlyPrincipalAndInterestPayment * this.remainingPayments;
    },
    principalBalanceEstimate() {
      // IPMT formula
      const monthlyRateDecimal = this.interestRatePercent / 100 / 12;

      return (
        (-1 *
          ((1 + monthlyRateDecimal) ** (this.monthsSinceLoanClose - 1) *
            (-1 * this.mortgageLoanAmount * monthlyRateDecimal +
              this.monthlyPrincipalAndInterestPayment) -
            this.monthlyPrincipalAndInterestPayment)) /
        monthlyRateDecimal
      );
    },
    newMonthlyPayment() {
      return this.monthlyPrincipalAndInterestPayment + this.monthlyExtraPayment;
    },
    newRemainingPayments() {
      return this.nper(
        this.interestRatePercent / 100 / 12,
        this.principalBalanceEstimate,
        this.newMonthlyPayment
      );
    },
    oneTimeRepaymentPeriodReducedBy() {
      return (
        this.remainingPayments -
        this.nper(
          this.interestRatePercent / 100 / 12,
          this.newPrincipalBalance,
          this.monthlyPrincipalAndInterestPayment
        )
      );
    },
    repaymentPeriodReducedBy() {
      return this.remainingPayments - Math.round(this.newRemainingPayments);
    },
    newRemainingMonthlyPrincipalAndInterest() {
      return this.newMonthlyPayment * this.newRemainingPayments;
    },
    monthlySavings() {
      return (
        this.remainingPrincipalAndInterest -
        this.newRemainingMonthlyPrincipalAndInterest
      );
    },
    newOneTimeRemainingPayments() {
      return this.nper(
        this.interestRatePercent / 100 / 12,
        this.newPrincipalBalance,
        this.monthlyPrincipalAndInterestPayment
      );
    },
    newRemainingOneTimePrincipalAndInterest() {
      return (
        this.monthlyPrincipalAndInterestPayment *
        this.newOneTimeRemainingPayments
      );
    },
    newPrincipalBalance() {
      return this.principalBalanceEstimate - this.oneTimeExtraPayment;
    },
    oneTimeSavings() {
      return (
        this.remainingPrincipalAndInterest -
        this.newRemainingOneTimePrincipalAndInterest
      );
    },
  },
  mounted() {
    $('.sliders').tooltip({ selector: '[data-toggle="tooltip"]' });
  },
  methods: {
    init() {
      return {
        isSubmitted: false,
        oneTimeExtraPayment: 1000,
        monthlyExtraPayment: 100,
        mortgageLoanAmount: 190000,
        // Month is 3 for april since month index goes from 0-11
        loanCloseDate: new Date(2016, 3, 1),
        interestRatePercent: 4.25,
        term: 30,
        errorMsgPre: 'Please enter a valid amount between',
        tab: 0,
      };
    },
    reset() {
      this.oneTimeExtraPayment = this.init().oneTimeExtraPayment;
      this.monthlyExtraPayment = this.init().monthlyExtraPayment;
      this.mortgageLoanAmount = this.init().mortgageLoanAmount;
      this.interestRatePercent = this.init().interestRatePercent;
      this.loanCloseDate = this.init().loanCloseDate;
      this.term = this.init().term;
    },
    pmt(rate, period, pv) {
      return (pv * rate) / (1 - (1 + rate) ** (-1 * period));
    },
    handleNegativeNums(n) {
      if (n < 0) {
        return 0;
      }
      return n;
    },
    currencyFormat(n) {
      return currency.format(n);
    },
    datePickerFormat(loanCloseDate) {
      return loanCloseDate.toLocaleDateString('en-US');
    },
    nper(rate, pv, pmt) {
      return (-1 * Math.log(1 - (rate * pv) / pmt)) / Math.log(1 + rate);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
